import styled from 'styled-components';

export const SectionWrapper = styled.section`
  padding: 4rem 1rem;
  background-color: #f9f9f9;
  text-align: center;
`;

export const ContentContainer = styled.div`
  max-width: 800px;
  margin: 0 auto;

  h2 {
    font-size: 2.5rem;
    color: #222;
    margin-bottom: 1.5rem;
  }

  p {
    font-size: 1.2rem;
    color: #555;
    line-height: 1.8;
  }

  @media (max-width: 768px) {
    h2 {
      font-size: 2rem;
    }

    p {
      font-size: 1rem;
    }
  }
`;
